import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsz76f854y: FaireProductEntity = {
  token: "p_nsz76f854y",
  type: "product",
  name: "Praise The Lord Christian Tee Unisex Faith-Based Shirt",
  brandToken: "b_2j7xk5pwsc",
  brandName: "TheKingShirt",
  imageUrl:
    "https://cdn.faire.com/fastly/a5785698d0b257d865aed65cb8a0d94ab42034262aac85b6c6b8c1f3abff9855.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3273587d10f20d62e805f6223b02e50f8cb1dbe45d11f25cc3ceb08645eef7eb.jpeg",
    "https://cdn.faire.com/fastly/29cef013e6f5dca8c9b10838a3493a61e96f322073f19c2167676f1943ba5031.jpeg",
  ],
  priceDollars: 17.99,
  description:
    "Product Details:\n•We use 100% cotton shirts.\n• All shirts are unisex and we use our own brand. (Please check our size chart in our listing.)\n•Heather colored adult shirts use 52% cotton and 48% polyester.\n\n-For detailed sizing information and t-shirt color options, please see listing images.\nOur shirts are small molded. It may be small for your normal size. Please refer to our size chart carefully before ordering.\n-Please check the our size chart and color of the shirt you want before ordering.\n\nWASHING INSTRUCTIONS:\nTurn inside out.\nMachine wash cold.\nTumble dry low.\nDo not bleach.\nDo not iron directly on design.\nHigh quality and super soft, comfortable tshirts.\n\nProcess and Shipping:\nProduction Time 1-3 business day\nUSA Orders / Standard: 3 to 7 business days\nUSA Orders / Rush: 3 to 5 business days\nInternational Orders: 1-2 weeks",
  tags: [],
  msrpDollars: 24.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:36.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
